import * as moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import { useRecoilState } from "recoil";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
  RSelect
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { popupPNCustomerFlowAtom, popupPNTransactionHistoryAtom } from "../../state";
import { pnTransactionHistoryListColTable } from "../../utils/col-table";
import { MONEY_TYPE, PN_CATEGORY_GROUP, renderPageStyle } from '../../utils/Utils';
import PNExchangeMoneyBetweenAccounts from "./PNExchangeMoneyBetweenAccounts";

const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));

const PNReportTransaction = () => {
  const printRef = useRef();
  const [popupPNCustomerFlow, setPopupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);
  const [popupPNTransactionHistory, setPopupPNTransactionHistory] = useRecoilState(popupPNTransactionHistoryAtom);
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [view, setView] = useState({
    EXCHANGE_BANK_ACCOUNT: false,
    isDelete: false,
  });

  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [pnCustomerOptions, setPNCustomerOptions] = useState([]);
  const [pnBankAccountOptions, setPNBankAccountOptions] = useState([]);
  const [pnCategoriesOptions, setPNCategoryOptions] = useState([]);
  const [pnUserOptions, setUserOptions] = useState([]);
  const [rangeDate, setRangeDate] = useState({
    fromDate: searchParams.get('fromDate') ? moment(searchParams.get('fromDate')).startOf('days').toDate() : moment().startOf('days').toDate(),
    toDate: searchParams.get('toDate') ? moment(searchParams.get('toDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    debtUserId: searchParams.get('debtUserId') || undefined,
    customerId: searchParams.get('customerId') || undefined,
    categoryId: searchParams.get('categoryId') || undefined,
    type: searchParams.get('type') || undefined,
    bankAccountId: searchParams.get('bankAccountId') || undefined,
  });

  const onRangeChange = (dates) => {
    const [fromDate, toDate] = dates;
    setRangeDate({
      fromDate: fromDate ? moment(fromDate)?.startOf('days').toDate() : fromDate,
      toDate: toDate ? moment(toDate)?.endOf('days').toDate() : toDate
    });
    if (fromDate && toDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = pnTransactionHistoryListColTable({
    actionCol: [
      {
        Header: "Hành động",
        accessor: (item) => (
          <ul className="nk-tb-actions gx-1">
            <li>
              <UncontrolledDropdown>
                <DropdownToggle
                  tag="a"
                  className="btn btn-icon dropdown-toggle btn-trigger"
                >
                  <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                  <ul className="link-list-opt no-bdr">
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();

                          if (item.customerId) {
                            setPopupPNCustomerFlow({
                              show: true,
                              data: {
                                id: '',
                                type: '',
                                transactionId: item.id,
                              }
                            })
                          } else {
                            setPopupPNTransactionHistory({
                              show: true,
                              data: {
                                id: item.id,
                                type: item.type
                              }
                            })
                          }
                        }}
                      >
                        <Icon name="edit" className="text-primary"></Icon>
                        <span>Sửa</span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();

                          if (item.customerId) {
                            setPopupPNCustomerFlow({
                              show: true,
                              data: {
                                id: '',
                                type: '',
                                duplicateTransactionId: item.id,
                              }
                            })
                          } else {
                            setPopupPNTransactionHistory({
                              show: true,
                              data: {
                                id: '',
                                duplicateId: item.id,
                                type: item.type
                              }
                            })
                          }
                        }}
                      >
                        <Icon name="copy" className="text-primary"></Icon>
                        <span>Nhân bản</span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setDeleteId(item.id);
                          toggle("isDelete");
                        }}
                      >
                        <Icon name="trash" className="text-danger"></Icon>
                        <span>Xoá</span>
                      </DropdownItem>
                    </li>
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            </li>
          </ul>
        ),
      },
    ]
  })

  useEffect(() => {
    GET(`/pn-customer`, {
    }, true)
      .then(({ data }) => {
        setPNCustomerOptions(data.map(c => ({
          label: c.name,
          value: c.id,
          data: c
        })))
      })

    GET(`/pn-category`, {}, true)
      .then(({ data }) => {
        setPNCategoryOptions(data.map(c => ({
          label: `${c.name} (${PN_CATEGORY_GROUP[c.group]})`,
          value: c.id,
          data: c
        })))
      })

    GET(`/pn-bank-account`, {}, true)
      .then(({ data }) => {
        setPNBankAccountOptions(data.map(c => ({
          label: c.name,
          value: c.id,
          data: c
        })))
      })

    GET("user", {
    }, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

  }, [])

  // Changing state value when searching name
  useEffect(() => {


    const newParams = new URLSearchParams({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.group ? { group: filter.group } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    let params = {
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
    };
    if (!!filter.group && !filter.categoryId) {
      params.categoryId = pnCategoriesOptions.filter(e => e.data.group === filter.group).map(e => e.data.id)
    }
    GET(`/pn-transaction-history`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData(rows);
        setSummary(summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter, popupPNCustomerFlow.updatedAt, popupPNTransactionHistory.updatedAt]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({
      isDelete: false,
      BANK_ACCOUNT: false,
      MORTGAGE_CONTRACT: false,
      EXCHANGE_BANK_ACCOUNT: false,
    });
    setEditedId();
    setDeleteId();
  };

  const deleteCustomer = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/pn-transaction-history/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const renderTable = useMemo(() => <Table
    loading={loading}
    columns={colTable}
    data={data}
    notShowPagi={true}
    headerRow={<tr className="font-weight-bold">
      <td colSpan={5} className="nk-tb-col"></td>
      <td className="nk-tb-col text-right">
        <NumericFormat
          displayType={"text"}
          value={summary?.totalAmountIn}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      </td>
      <td className="nk-tb-col text-right" >
        <NumericFormat
          displayType={"text"}
          value={summary?.totalAmountOut}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      </td>
      <td colSpan={1} className="nk-tb-col">
        <span> Tổng cộng</span>
      </td>
      <td className="nk-tb-col text-right" colSpan={2}>
        <NumericFormat
          displayType={"text"}
          value={summary?.totalAmount}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      </td>
    </tr>}
  ></Table>, [data, loading])

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.group ? { group: filter.group } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(filter.bankAccountId ? { bankAccountId: filter.bankAccountId } : {}),
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-transaction-history/list-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Quản lý thu chi Phương Nam"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.fromDate}
                          startDate={rangeDate.fromDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.toDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm NV"
                          classNamePrefix="form-control"
                          options={pnUserOptions}
                          value={pnUserOptions.find(
                            (c) => c.value === filter.debtUserId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              debtUserId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm KH/NCC"
                          classNamePrefix="form-control"
                          options={pnCustomerOptions}
                          value={pnCustomerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm tài khoản"
                          classNamePrefix="form-control"
                          options={pnBankAccountOptions}
                          value={pnBankAccountOptions.find(
                            (c) => +c.value === +filter.bankAccountId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              bankAccountId: val?.value || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm Danh mục"
                          classNamePrefix="form-control"
                          options={pnCategoriesOptions}
                          value={pnCategoriesOptions.find(
                            (c) => c.value === filter.categoryId
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryId: (val && val.value) || null,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm Loại"
                          classNamePrefix="form-control"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button className={`btn-secondary`}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="btn-secondary ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("EXCHANGE_BANK_ACCOUNT");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Chuyển TK khác</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <style>{renderPageStyle({
                    hiddenActionCol: true,
                  })}</style>
                  <h5 className="text-center mt-2">Báo cáo chi tiết thu chi Phương Nam từ {moment(rangeDate.fromDate).format('DD-MM-YYYY')} đến {moment(rangeDate.toDate).format('DD-MM-YYYY')}</h5>
                  {renderTable}
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.EXCHANGE_BANK_ACCOUNT}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <PNExchangeMoneyBetweenAccounts
            pnBankAccountOptions={pnBankAccountOptions}
            id={editId}
            onClose={resetData}
          />
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá thu chi này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteCustomer(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>


      </Content>
    </React.Fragment>
  );
};

export default PNReportTransaction
